import {
  GET_WORKFLOW_STATE,
  INITIALIZE_WORKFLOW_STATE,
  RESET_WORKFLOW_STATE,
  UPDATE_WORKFLOW_STATE,
} from "../actionTypes/workFLowType";

export const initialWorkFlowState = {
  isApiCallNeed: true,
  authenticationSettings: {
    type: "",
    active: "",
  },
  maintenanceSettings: {
    active: "",
    imageToken: "",
  },
  languageSettings: {
    languageCode: "",
  },
  backgroundSettings: {
    active: "",
    imageToken: "",
  },
  themeSettings: {
    customerLogoToken: "",
    customerLogoLink: "",
    progressBarPrimaryColor: "",
    progressBarSecondaryColor: "",
    virtualTitleEn: "",
    virtualTitleAr: "",
    virtualContentEn: "",
    virtualContentAr: "",
    virtualImageToken: "",
    primaryButtonColor: "",
    primaryButtonHoverColor: "",
    pagebackgroundColor: "",
    inputBorderColor: "",
    inputActiveBorderColor: "",
    termsAndConditionsContentEn: "",
    termsAndConditionsContentAr: "",
    preJoinScreenNoteEn: "",
    preJoinScreenNoteAr: "",
    lobbyScreenTitle1En: "",
    lobbyScreenTitle1Ar: "",
    lobbyScreenTitle2En: "",
    lobbyScreenTitle2Ar: "",
    lobbyScreenTitle3En: "",
    lobbyScreenTitle3Ar: "",
    lobbyScreenSubTitle1En: "",
    lobbyScreenSubTitle1Ar: "",
    lobbyScreenSubTitle2En: "",
    lobbyScreenSubTitle2Ar: "",
    lobbyScreenImageToken: "",

    backgroundColor: "",
    primaryColor: "",
    onPrimaryColor: "",
    secondaryColor: "",
    onSecondaryColor: "",
    neutralColor: "",
  }
};

export const workFlowReducer = (state = initialWorkFlowState, action = {}) => {
  switch (action.type) {
    case INITIALIZE_WORKFLOW_STATE: {
      return {
        ...state,
      };
    }

    case GET_WORKFLOW_STATE: {
      return {
        ...state,
      };
    }

    case UPDATE_WORKFLOW_STATE: {
      state = { ...state, ...action.payload };
      return {
        ...state,
        ...action.payload,
      };
    }

    case RESET_WORKFLOW_STATE: {
      state = initialWorkFlowState;
      return {
        ...state,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
